import { AnalyticsECommerceUniversalShoppingBasketProductType } from '#src/components/Common/analytics/AnalyticsECommerce/AnalyticsECommerce.types';
import { eCommerceProductTypeMapper } from '#src/components/Common/analytics/AnalyticsECommerce/utils/mapECommerceProductName';
import { UniversalShoppingBasketProductType } from '#src/generated/graphql';
import { AnalyticsProductType } from '#src/utils';

const mapper: Record<
  AnalyticsECommerceUniversalShoppingBasketProductType,
  string
> = {
  ACCOMMODATION: 'HO',
  BAGGAGE: 'BG',
  SEAT: 'ST',
  AIRPORT_FAST_TRACK: 'FT',
  ITINERARY_PRICE_FREEZE: 'PFFI',
  MEMBERSHIP_SUBSCRIPTION: 'SP',
  MEMBERSHIP_RENEWAL: 'SP',
};

export const isShoppingBasketProductsLoaded = (products, loading) => {
  return !loading && products.length > 0;
};

export const productTypeToAnalyticsProductType = (
  productType
): AnalyticsProductType => {
  if (!eCommerceProductTypeMapper[productType]) {
    return 'unknown';
  }

  return eCommerceProductTypeMapper[
    productType
  ].toLowerCase() as AnalyticsProductType;
};

export const productTypeToAnalyticsProductCode = (productType) => {
  if (!mapper[productType]) {
    return 'unknown';
  }

  return mapper[productType];
};

export const productTypeArrayToAnalyticsProductTypeArray = (
  productTypes
): AnalyticsProductType[] =>
  productTypes.map(productTypeToAnalyticsProductType);

export const productTypeArrayToAnalyticsProductCodeArray = (
  productTypes
): AnalyticsProductType[] =>
  productTypes.map(productTypeToAnalyticsProductCode);

export const groupProductsByType = (products) =>
  products.reduce((result: UniversalShoppingBasketProductType[], product) => {
    if (!result.includes(product.type)) {
      result.push(product.type);
    }
    return result;
  }, []);

export const groupProductsIdsByProductType = (products) =>
  products.reduce((result, item) => {
    return {
      ...result,
      [item.type]: [...(result[item.type] ?? []), item.id],
    };
  }, {});

export const groupBundlesIdsByBundleType = (bundles) =>
  bundles.reduce((result, item) => {
    return {
      ...result,
      [item.type]: [...(result[item.type] ?? []), item.id],
    };
  }, {});
